import { useAppStore } from 'stores/state';
import { endpoints } from './endpoints';
import { assertString } from '@wix/gg-common-lib/utils';
import { templates } from 'config/templates';
import { STORES_APP_DEF_ID } from 'config/consts';
import { V1TenantType } from '@wix/ambassador-apps-v1-app-instance/types';
import { FLOW_NAME_PREFIX } from 'config/bi-events';
import { businessTermByCategory } from 'config/maps';
import { biEvents } from './bi-events';
import { useProductStore } from 'stores/product';

const createSitelessMetasite = async () => {
  const response = await endpoints.createSitelessMetasite({ name: 'my-store', flowName: FLOW_NAME_PREFIX });
  useAppStore.setState({ metaSiteId: response.metaSite?.metaSiteId });
};

const createSiteFromTemplate = async () => {
  const { templateSlug } = useAppStore.getState();
  assertString(templateSlug);
  const originTemplateId = templates[templateSlug]?.msid;
  const response = await endpoints.createSiteFromTemplate({ originTemplateId, flowName: FLOW_NAME_PREFIX });
  useAppStore.setState({ metaSiteId: response.metaSite?.metaSiteId });
};

const attachSiteToMetasite = async () => {
  const { templateSlug } = useAppStore.getState();
  assertString(templateSlug);
  const templateMetaSiteId = templates[templateSlug]?.msid;
  await endpoints.attachSiteToMetasite({ templateMetaSiteId });
};

const installSiteApps = async () => {
  const { metaSiteId } = useAppStore.getState();
  assertString(metaSiteId);
  const appInstances = [{ appDefId: STORES_APP_DEF_ID }];
  await endpoints.installSiteApps({ appInstances, tenant: { id: metaSiteId, tenantType: V1TenantType.SITE } });
};

const updateSiteSettings = async () => {
  const { siteName, category } = useAppStore.getState();
  const categories = category ? businessTermByCategory[category] : undefined;
  const params = { siteDisplayName: siteName, ...(categories ? { categories } : {}) };
  await endpoints.updateSiteSettings(params);
};

const reportFlowSummary = () => {
  const { metaSiteId, category, catalogSize, sellingTypes, currentPlatform, currentPlatformUrl, siteName, storeType } =
    useAppStore.getState();
  assertString(metaSiteId);
  biEvents.flowSummary({
    msid: metaSiteId,
    data: JSON.stringify({
      currentPlatformUrl,
      currentPlatform,
      sellingTypes,
      catalogSize,
      storeType,
      category,
      siteName,
    }),
  });
};

const emptyStoreCatalog = async () => {
  await endpoints.emptyStoreCatalog({});
};

const addSingleProductToStore = async () => {
  const { productName, productDescription, productPrice, productImages } = useProductStore.getState();
  await endpoints.addProductsToSiteCatalog({
    products: [
      { name: productName, description: productDescription, price: Number(productPrice), images: productImages },
    ],
  });
};

export const actions = {
  createSitelessMetasite,
  createSiteFromTemplate,
  attachSiteToMetasite,
  installSiteApps,
  updateSiteSettings,
  reportFlowSummary,
  emptyStoreCatalog,
  addSingleProductToStore,
};
